import lightGallery from 'lightgallery';
import lgFullscreen from 'lightgallery/plugins/fullscreen';
import lgHash from 'lightgallery/plugins/hash';
import lgOriginCrop from 'lightgallery/plugins/originCrop';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

const strings = {
    closeGallery: 'Zatvori galeriju',
    toggleMaximize: 'Prikaži preko cijelog prozora',
    previousSlide: 'Prethodna slika',
    nextSlide: 'Sljedeća slika',
    download: 'Preuzmi sliku',
    mediaLoadingFailed: 'Slika se nije uspjela učitati.',
    galleryLabel: 'Galerija snimki zaslona',
    slideAnnouncement: 'Slika {index} od {total}',
    moreOptions: 'Više opcija',
    toggleThumbnails: 'Prikaži ili sakrij sličice',
    toggleFullscreen: 'Prikaz preko cijelog zaslona',
    zoomIn: 'Povećaj',
    zoomOut: 'Smanji',
    viewActualSize: 'Stvarna veličina',
};

// Mrežu slaže CSS; sličice su izrezane (object-fit: cover), pa otvaranje kreće od vidljivog dijela
function initGalleries() {
    document.querySelectorAll('.screenshots__gallery').forEach((gallery) => {
        lightGallery(gallery, {
            plugins: [lgOriginCrop, lgThumbnail, lgZoom, lgFullscreen, lgHash],
            licenseKey: window.w4d_screenshots?.licenseKey || '',
            strings,
            galleryId: gallery.dataset.gallery,
            download: false,
            mobileSettings: {controls: false, showCloseIcon: true, download: false},
        });
    });
}

// Označava sekciju koja je trenutačno u vidnom polju u bočnoj navigaciji. Zadnja sekcija postaje
// aktivna i kada je stranica pomaknuta do dna, jer kratka sekcija ne može doći do vrha prozora.
function initSectionNav() {
    const links = [...document.querySelectorAll('.screenshots-nav a[href^="#"]')];
    const sections = links.map((link) => document.getElementById(decodeURIComponent(link.hash.slice(1))));
    if (!links.length || sections.includes(null)) {
        return;
    }

    let frame = 0;
    const update = () => {
        frame = 0;
        const threshold = window.innerHeight * 0.3;
        const atBottom = window.scrollY > 0 && window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
        let current = atBottom ? sections.length - 1 : -1;
        if (!atBottom) {
            sections.forEach((section, index) => {
                if (section.getBoundingClientRect().top <= threshold) {
                    current = index;
                }
            });
        }
        links.forEach((link, index) => {
            if (index === Math.max(current, 0)) {
                link.setAttribute('aria-current', 'location');
            } else {
                link.removeAttribute('aria-current');
            }
        });
    };

    window.addEventListener('scroll', () => {
        frame ||= requestAnimationFrame(update);
    }, {passive: true});
    update();
}

document.addEventListener('DOMContentLoaded', () => {
    initGalleries();
    initSectionNav();
});
